/* Two decoded-video layers. Incoming opacity rises over a fully opaque outgoing frame. */
(() => {
 if (window.AuluoFilmV20) return;
 const instances = new WeakMap();
 function init(scope = document) {
  scope.querySelectorAll('.a13-film').forEach(s => enhance(s));
 }
 function enhance(s) {
 if (instances.has(s)) return;
 const cleanup = [];
 let destroyed = false;
 const on = (target, name, handler, options) => { target.addEventListener(name, handler, options); cleanup.push(() => target.removeEventListener(name, handler, options)); };

 let clips;try{clips=JSON.parse(s.parentElement.querySelector('[data-auluo-playlist]').textContent);}catch{return;}
 if(!clips?.length)return;
 const layers=Array.from(s.querySelectorAll('.a13-layer'));
 const videos=layers.map(l=>l.querySelector('video'));
 const posters=layers.map(l=>l.querySelector('img'));
 const list=s.querySelector('.a14-chapters');
 const indicator=list.querySelector('.a14-chapter-indicator');
 const gold=indicator.querySelector('.a16-chapter-gold');
 const surface=s.querySelector('.a13-surface-toggle');
 const play=s.querySelector('.a14-play');
 const status=s.querySelector('.a10-film__status');
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const fadeMs=650;
 let front=0,current=0,visible=false,userPaused=reduced.matches,busy=false,queued=null,started=false,attempt=0,pageActive=true;
 let failed=new Set();
 const assigned=[-1,-1];
 const activeSlots=new Set();
 const textAnimations=[[],[]];
 const chapterNames=[...new Set(clips.map(c=>c.chapter))];
 const chapterStarts=chapterNames.map(name=>clips.findIndex(c=>c.chapter===name));
 let highlightedChapter=-1;
 let goldActive=false;
 let goldAnimation=null;
 const shouldPlay=()=>!destroyed&&pageActive&&visible&&!document.hidden&&!userPaused;
 const buttons=chapterNames.map((name,i)=>{
  const b=document.createElement('button');b.type='button';
  const label=document.createElement('span');label.className='a14-chapter-label';
  const clip=clips[chapterStarts[i]];
  if(clip.chapterLogo){
   const logo=document.createElement('img');logo.src=clip.chapterLogo;logo.alt='';logo.width=64;logo.height=20;logo.decoding='async';label.appendChild(logo);b.classList.add('a16-logo-tab');
  }else label.textContent=name;
  b.appendChild(label);b.setAttribute('aria-label','Ver capítulo: '+name);
  b.addEventListener('click',()=>{const index=chapterStarts[i];failed.delete(index);userPaused=false;request(index,true);});
  list.appendChild(b);return b;
 });
 s.classList.add('is-enhanced');list.hidden=false;surface.hidden=false;play.hidden=false;
 videos.forEach(v=>{v.muted=true;v.defaultMuted=true;v.playsInline=true;v.controls=false;v.preload='none';});
 function moveIndicator(){
  const b=buttons[highlightedChapter];if(!b)return;
  indicator.style.width=b.offsetWidth+'px';
  indicator.style.setProperty('transform','translateX('+b.offsetLeft+'px)','important');
 }
 function selectChapter(index,animate=true){
  const next=chapterNames.indexOf(clips[index].chapter);
  const isBrand=clips[index].mode==='brand';
  const enteringBrand=isBrand&&!goldActive;
  goldActive=isBrand;
  list.dataset.accent=isBrand?'gold':'white';
  if(!isBrand){
   goldAnimation?.cancel();goldAnimation=null;
  }
  buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===next)));
  highlightedChapter=next;moveIndicator();
  const label=buttons[next].firstElementChild;
  if(animate&&!reduced.matches&&label.animate){
   label.getAnimations?.().forEach(a=>a.cancel());
   label.animate([{opacity:.4,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,easing:'cubic-bezier(.22,.61,.36,1)'});
  }
  if(enteringBrand&&animate&&!reduced.matches&&gold?.animate){
   goldAnimation?.cancel();
   goldAnimation=gold.animate([{transform:'scaleX(0)',opacity:0},{transform:'scaleX(1)',opacity:1}],{duration:900,easing:'cubic-bezier(.22,.61,.36,1)'});
  }
 }
 function populateCopy(slot,clip){
  textAnimations[slot].forEach(a=>a.cancel());textAnimations[slot]=[];
  const kicker=layers[slot].querySelector('.a39-film-kicker');
  if(kicker){kicker.textContent=clip.kicker||'';kicker.hidden=!clip.kicker;}
  const heading=layers[slot].querySelector('.a14-headline');heading.replaceChildren();heading.setAttribute('aria-label',clip.headline.join(' '));
  layers[slot].querySelector('.a14-copy').hidden=!clip.headline.length&&!clip.caption;
  heading.hidden=!clip.headline.length;
  let number=0;
  clip.headline.forEach((line,lineIndex)=>{
   const row=document.createElement('span');row.className='a14-line';
   row.dataset.finish=clip.lineFinishes?.[lineIndex]||'silver';
   line.split(' ').forEach((word,i)=>{if(i)row.appendChild(document.createTextNode(' '));const token=document.createElement('span');token.className='a14-word';token.textContent=word;token.dataset.order=String(number++);row.appendChild(token);});
   heading.appendChild(row);
  });
  const caption=layers[slot].querySelector('.a14-caption');caption.textContent=clip.caption;caption.hidden=!clip.caption;
 }
 function animateCopy(slot){
  textAnimations[slot].forEach(a=>a.cancel());textAnimations[slot]=[];
  if(reduced.matches)return;
  const words=layers[slot].querySelectorAll('.a14-word');
  words.forEach((word,i)=>{
   if(!word.animate)return;
   textAnimations[slot].push(word.animate([{opacity:0,transform:'translateY(14px)'},{opacity:1,transform:'translateY(0)'}],{duration:650,delay:110+i*48,easing:'cubic-bezier(.22,.61,.36,1)',fill:'backwards'}));
  });
  const caption=layers[slot].querySelector('.a14-caption');
  if(caption.animate)textAnimations[slot].push(caption.animate([{opacity:0,transform:'translateY(7px)'},{opacity:1,transform:'translateY(0)'}],{duration:600,delay:280,easing:'ease-out',fill:'backwards'}));
 }
 function sync(){
  const playing=videos.some(v=>!v.paused&&!v.ended)&&!userPaused;
  s.classList.toggle('is-playing',playing);
  surface.setAttribute('aria-label',playing?'Pausar vídeo':'Reproducir vídeo');
  play.setAttribute('aria-label',playing?'Pausar vídeo':'Reproducir vídeo');
  play.setAttribute('aria-pressed',String(playing));
  play.innerHTML=playing?'<span aria-hidden="true">Ⅱ</span> Pausar':'<span aria-hidden="true">▷</span> Reproducir';
  if(!busy)selectChapter(current,false);
 }
 function assign(slot,index){
  if(assigned[slot]===index)return;
  const clip=clips[index],v=videos[slot];
  v.pause();layers[slot].classList.remove('is-decoded');
  layers[slot].dataset.mode=clip.mode||'portrait';
  layers[slot].dataset.scene=clip.id;
  populateCopy(slot,clip);
  posters[slot].src=clip.poster;v.poster=clip.poster;
  v.setAttribute('aria-label','Vídeo: '+clip.title);
  assigned[slot]=index;v.preload='auto';
  v.replaceChildren();
  if(clip.fallbackSrc){
   // The supplied original stays first and byte-for-byte unchanged. Native
   // source selection uses H.264 only when the device cannot decode HEVC.
   v.removeAttribute('src');
   for(const [src,type] of [[clip.src,clip.sourceType],[clip.fallbackSrc,clip.fallbackType]]){
    const source=document.createElement('source');source.src=src;
    if(type)source.type=type;
    v.appendChild(source);
   }
  }else v.src=clip.src;
  v.load();
 }
 function ready(v){
  if(v.error)return Promise.reject(new Error('media'));
  if(v.readyState>=2)return Promise.resolve();
  return new Promise((resolve,reject)=>{
   let timer;
   const clean=()=>{clearTimeout(timer);v.removeEventListener('loadeddata',yes);v.removeEventListener('error',no);};
   const yes=()=>{clean();resolve();};const no=()=>{clean();reject(new Error('media'));};
   v.addEventListener('loadeddata',yes,{once:true});v.addEventListener('error',no,{once:true});
   timer=setTimeout(no,10000);
  });
 }
 function frame(v){
  // loadeddata has already provided a decoded frame. Prefer a presented frame when supported.
  return new Promise(resolve=>{
   let timer,id,done=false;
   const finish=()=>{if(done)return;done=true;clearTimeout(timer);if(id!==undefined&&v.cancelVideoFrameCallback)v.cancelVideoFrameCallback(id);resolve();};
   if(v.requestVideoFrameCallback){id=v.requestVideoFrameCallback(finish);timer=setTimeout(finish,350);}
   else requestAnimationFrame(()=>requestAnimationFrame(finish));
  });
 }
 function preloadNext(){
  if(clips.length<2)return;
  const next=(current+1)%clips.length;
  if(!failed.has(next))assign(1-front,next);
 }
 async function safePlay(slot){
  if(!shouldPlay())return false;
  activeSlots.add(slot);
  // Call play before waiting for loadeddata. On a touch retry, the call stays
  // inside the user gesture; mobile browsers need not preload decoded frames.
  let timer;
  try{await Promise.race([videos[slot].play(),new Promise((_,reject)=>{timer=setTimeout(()=>reject(new Error('play-timeout')),12000);})]);}
  catch(e){videos[slot].pause();activeSlots.delete(slot);throw e;}
  finally{clearTimeout(timer);}
  if(!shouldPlay()){videos[slot].pause();return false;}
  return true;
 }
 async function revealInitial(){
  if(busy||!shouldPlay())return;
  busy=true;const token=++attempt;
  try{
   assign(front,current);
   if(!await safePlay(front))return;
   await ready(videos[front]);
   if(token!==attempt||!shouldPlay())return;
   await frame(videos[front]);
   if(token!==attempt)return;
   layers[front].classList.add('is-decoded');animateCopy(front);selectChapter(current);started=true;status.textContent='';preloadNext();
  }catch(e){if(shouldPlay()){userPaused=true;status.textContent='Toca Reproducir para iniciar el vídeo.';}}
  finally{busy=false;sync();drain();}
 }
 function drain(){
  if(busy||!shouldPlay())return;
  if(queued!==null){const next=queued;queued=null;request(next);}
 }
 async function request(index,manual=false){
  index=(index+clips.length)%clips.length;
  if(manual)userPaused=false;
  if(busy){queued=index;return;}
  if(!shouldPlay()){queued=index;return;}
  if(index===current){
   queued=null;
   if(!started)return revealInitial();
   if(videos[front].ended)videos[front].currentTime=clips[current].startAt||0;
   try{await safePlay(front);status.textContent='';}catch{status.textContent='Pulsa sobre el vídeo para reproducirlo.';}
   sync();return;
  }
  busy=true;const token=++attempt,old=front,target=1-front;
  try{
   assign(target,index);
   videos[target].currentTime=clips[index].startAt||0;
   if(!await safePlay(target)){if(queued===null)queued=index;return;}
   await ready(videos[target]);
   if(token!==attempt||!shouldPlay()){if(queued===null)queued=index;return;}
   await frame(videos[target]);
   if(token!==attempt)return;
   layers[target].classList.add('is-decoded');
   layers[target].style.zIndex='2';layers[old].style.zIndex='1';
   layers[target].style.opacity='0';layers[old].style.opacity='1';
   layers[target].removeAttribute('aria-hidden');layers[old].setAttribute('aria-hidden','true');
   animateCopy(target);selectChapter(index);
   s.dataset.mode=clips[index].mode||'portrait';status.textContent='';
   // A source marked "cut" plays as supplied: no blended frames at either edge.
   const duration=reduced.matches||clips[index].transition==='cut'||clips[current].transition==='cut'?0:fadeMs;
   if(duration&&typeof layers[target].animate==='function'){
    const animation=layers[target].animate([{opacity:0},{opacity:1}],{duration,easing:'cubic-bezier(.22,.61,.36,1)',fill:'forwards'});
    try{await animation.finished;}catch{}
    layers[target].style.opacity='1';animation.cancel();
   }else layers[target].style.opacity='1';
   if(token!==attempt)return;
   videos[old].pause();activeSlots.delete(old);layers[old].style.opacity='0';layers[old].style.zIndex='0';
   layers[target].style.zIndex='1';layers[target].removeAttribute('aria-hidden');layers[old].setAttribute('aria-hidden','true');
   videos[target].removeAttribute('aria-hidden');videos[old].setAttribute('aria-hidden','true');
   front=target;current=index;started=true;
   if(!shouldPlay())videos[front].pause();
   failed.delete(index);preloadNext();
  }catch(e){
   videos[target].pause();activeSlots.delete(target);layers[target].style.opacity='0';
   layers[target].setAttribute('aria-hidden','true');layers[old].removeAttribute('aria-hidden');selectChapter(current,false);
   if(e.name==='NotAllowedError'){queued=index;userPaused=true;status.textContent='Toca Reproducir para continuar.';}
   else if(e.name==='AbortError'||!visible||document.hidden||!pageActive){if(queued===null)queued=index;}
   else{failed.add(index);status.textContent='Este vídeo no se pudo cargar. Puedes elegir otro.';}
  }finally{busy=false;sync();drain();}
 }
 function next(){
  if(busy||!shouldPlay()||clips.length<2)return;
  for(let step=1;step<clips.length;step++){const n=(current+step)%clips.length;if(!failed.has(n)){request(n);return;}}
 }
 videos.forEach((v,slot)=>{
  on(v,'loadedmetadata',()=>{
   const start=clips[assigned[slot]]?.startAt||0;
   if(start>0&&Number.isFinite(v.duration)&&v.currentTime<start){
    v.currentTime=Math.min(start,Math.max(0,v.duration-.05));
   }
  });
  ['play','pause'].forEach(event=>v.addEventListener(event,sync));
  v.addEventListener('timeupdate',()=>{
   const nextIndex=(current+1)%clips.length;
   if(clips[current].transition==='cut'||clips[nextIndex].transition==='cut')return;
   if(slot===front&&started&&v.duration>0&&v.duration-v.currentTime<=fadeMs/1000)next();
  });
  v.addEventListener('ended',()=>{if(slot===front)next();});
 });
 function toggle(){
  if(videos.some(v=>!v.paused&&!v.ended)&&!userPaused){userPaused=true;videos.forEach(v=>v.pause());status.textContent='En pausa. Pulsa sobre el vídeo para continuar.';}
  else{userPaused=false;status.textContent='';if(queued!==null)drain();else request(current,true);}
  sync();
 }
 surface.addEventListener('click',toggle);play.addEventListener('click',toggle);
 function visibility(){
  if(!shouldPlay()){videos.forEach(v=>v.pause());sync();return;}
  if(busy){activeSlots.forEach(slot=>safePlay(slot).catch(()=>{}));return;}
  if(queued!==null)drain();else request(current);
 }
 // Observe the scene, not the control rail: a rail peeking under the sticky
 // header must not keep decoding clips whose picture is already offscreen.
 if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{entries.forEach(e=>{visible=e.isIntersecting&&e.intersectionRatio>=.15;visibility();});},{threshold:[0,.15],rootMargin:'-88px 0px 0px 0px'});observer.observe(s.querySelector('.a13-stage'));cleanup.push(()=>observer.disconnect());}
 else{visible=true;}
 on(document,'visibilitychange',visibility);
 on(window,'pagehide',()=>{pageActive=false;visibility();});
 on(window,'pageshow',()=>{pageActive=true;visibility();});
 on(reduced,'change',e=>{if(e.matches){userPaused=true;videos.forEach(v=>v.pause());sync();}});
 if('ResizeObserver'in window){const observer=new ResizeObserver(moveIndicator);observer.observe(list);cleanup.push(()=>observer.disconnect());}
 else on(window,'resize',moveIndicator);
 if(document.fonts?.ready)document.fonts.ready.then(()=>{if(!destroyed)moveIndicator();});
 s.dataset.mode=clips[0].mode||'portrait';sync();
 if(visible)visibility();
 instances.set(s, {destroy(){
  destroyed=true;++attempt;userPaused=true;queued=null;
  cleanup.forEach(fn=>fn());textAnimations.flat().forEach(a=>a.cancel());goldAnimation?.cancel();
  layers.forEach(l=>l.getAnimations?.().forEach(a=>a.cancel()));
  videos.forEach(v=>{v.pause();v.removeAttribute('src');v.querySelectorAll('source').forEach(source=>source.removeAttribute('src'));v.load();});
  instances.delete(s);
 }});
 }
 document.addEventListener('shopify:section:load', event=>init(event.target));
 document.addEventListener('shopify:section:unload', event=>event.target.querySelectorAll('.a13-film').forEach(s=>instances.get(s)?.destroy()));
 window.AuluoFilmV20={init};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();
